import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RoomActions, RoomApiActions } from './room.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { CalendarService } from '../../services/calendar/calendar.service';

@Injectable()
export class RoomEffects {
    constructor(
        private actions$: Actions,
        private calendarService: CalendarService
    ) {}

    loadRooms$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RoomApiActions.loadRooms),
            switchMap(() =>
                this.calendarService.loadRooms().pipe(
                    map((rooms) => RoomActions.loadRoomsSuccess({ rooms })),
                    catchError((error) => of(RoomActions.loadRooomsFailure({ error })))
                )
            )
        );
    });

    createRoom$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RoomApiActions.createRoom),
            switchMap(({ room }) =>
                this.calendarService.createRoom(room).pipe(
                    map((room) => RoomActions.createRoomSuccess({ room })),
                    catchError((error) => of(RoomActions.createRoomFailure({ error })))
                )
            )
        );
    });
}
